import { gql } from 'apollo-boost';

const ADD_USER = gql`
  mutation AddNewUser(
    $firstName: String
    $lastName: String
    $email: String
    $tel: String
    $addressId: ID
    $unit: String
    $street: String
    $city: String
    $province: String
    $country: String
    $postalCode: String
    $lat: String
    $long: String
  ) {
    addNewUser(
      firstName: $firstName
      lastName: $lastName
      email: $email
      tel: $tel
      addressId: $addressId
      unit: $unit
      street: $street
      city: $city
      province: $province
      country: $country
      postalCode: $postalCode
      lat: $lat
      long: $long
    ) {
      success
      message
      user {
        id
        firstName
        lastName
        tel
        email
        stripe
        new
        address {
          id
          street
          unit
          city
          province
        }
      }
    }
  }
`;

export default ADD_USER;